module MyPaymentHistory {
    RequireLogin(() => InitializePaymentHistory());

    var paymentListElementHtml = `
                    <td id="Sum" class="hidden-xs">Online</td>
                    <td id="Type"></td>
                    <td id="Date"></td>
                    <td id="State" class="hidden-xs hidden-sm"></td>`;

    function InitializePaymentHistory() {
        $("#SmsLeft").html(webUser.smsBalance.toString());
        $("#SmsSent").html(webUser.smsSent.toString());

        for (var i = 0; i < webUser.payments.length; i++) {
            var element = document.createElement("tr");
            element.innerHTML = paymentListElementHtml;
            document.getElementById('paymentList').appendChild(element);
            element.querySelector("#Sum").innerHTML = webUser.payments[i].totalSum.toString() + localizer["CurrencyNokShort"];
            element.querySelector("#Type").innerHTML = ProductToString(webUser.payments[i].product);
            element.querySelector("#Date").innerHTML = DateToDateYearString(webUser.payments[i].paymentReceivedTime);
            element.querySelector("#State").innerHTML = webUser.payments[i].isPaymentCompleted ? localizer["MyPaymentHistoryCompleted"] : localizer["MyPaymentHistoryAwaitingPayment"];
        }
    }

    function ProductToString(product: CustomerAPI.Product): string
    {
        return product == CustomerAPI.Product.SmsPackage ? localizer["MyPaymentHistorySmsPack"] : localizer["MyPaymentHistorySubscription"];
    }
}